import Vue from 'vue';

export default {
  addPaymentOrder(orderId) {
    return Vue.prototype.axios
      .post('addPaymentOrder', {
        params: {
          orderId,
          transactionNumber: 1,
          userId: 1,
          dealerId: Vue.prototype.$session.get('dealerId'),
        },
      })
      .then((res) => {
        const response = res.data;

        if (!response.success) throw new Error(`[${response.errorCode}] ${response.errorDescription}`);

        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
  createExitSurvey() {
    return Vue.prototype.axios
      .post('createExitSurvey', {
        params: {
          // dealerId: 1,
          dealerId: Vue.prototype.$session.get('dealerId'),
          orderId: Vue.prototype.$session.get('orderId'),
          customerIdDMS: 1,
          customerIdSF: 1,
          name: 'Jhon',
          lastName: 'Doe',
          email: 'jhon@doe.com',
          phone: '000000',
          status: 'paid',
        },
      })
      .then((res) => {
        const responseSurvey = res.data;

        if (!responseSurvey.success) throw new Error(`[${responseSurvey.errorCode}] ${responseSurvey.errorDescription}`);

        return responseSurvey;
      })
      .catch((error) => {
        throw error;
      });
  },
};
